import { render, staticRenderFns } from "./ProductivityContentV3CS.vue?vue&type=template&id=dcef5142&"
import script from "./ProductivityContentV3CS.vue?vue&type=script&lang=js&"
export * from "./ProductivityContentV3CS.vue?vue&type=script&lang=js&"
import style0 from "./ProductivityContentV3CS.vue?vue&type=style&index=0&id=dcef5142&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports